import { render, staticRenderFns } from "./RemoteConsultationReject.vue?vue&type=template&id=83ab2b74&"
import script from "./RemoteConsultationReject.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports